const pad2 = (value) => (value < 10 ? '0' + value : String(value))

/** 导出日期标记，按浏览器本地时区生成 YYYY-MM-DD。 */
export function formatExportDate (date) {
    const d = Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime()) ? date : new Date()
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

/**
 * 在文件名末尾（扩展名之前）追加导出日期，便于区分不同日期导出的文件。
 * 文件名里已经带当天日期时保持原样，避免重复追加。
 */
export function withExportDate (fileName, date) {
    const name = String(fileName == null ? '' : fileName).trim() || '导出文件'
    const stamp = formatExportDate(date)
    const dot = name.lastIndexOf('.')
    const slash = name.lastIndexOf('/')
    const hasExt = dot > 0 && dot > slash
    const base = hasExt ? name.slice(0, dot) : name
    const ext = hasExt ? name.slice(dot) : ''
    if (base.indexOf(stamp) > -1) {
        return base + ext
    }
    return `${base}-${stamp}${ext}`
}

/** 从 content-disposition 里取后端给的文件名，解码失败时返回空串。 */
export function parseDispositionFileName (disposition) {
    const matched = String(disposition || '').match(/filename\*=UTF-8''([^;]+)/i)
    if (!matched) {
        return ''
    }
    try {
        return decodeURIComponent(matched[1].trim().replace(/^"|"$/g, ''))
    } catch (e) {
        return ''
    }
}
